import { Link } from "react-router-dom";
import { ClipboardList, ArrowRight, Trophy } from "lucide-react";
import { useApi } from "../../lib/api";
import { Stagger, AnimatedCard } from "../../components/motion";
import { PageHeader, SkeletonGrid, EmptyState, ErrorState, Badge } from "../../components/common";

export default function Exams() {
  const { data, loading, error, reload } = useApi("/me/exams");
  return (
    <div>
      <PageHeader eyebrow="Değerlendirme" title="Sınavlarım" desc="Eğitimlerinize bağlı sınavlar ve sonuçlarınız." />
      {error ? (
        <ErrorState message={error} onRetry={reload} />
      ) : loading ? (
        <SkeletonGrid count={2} className="h-52" cols="md:grid-cols-2" />
      ) : data.length === 0 ? (
        <EmptyState icon={ClipboardList} title="Henüz bir sınavınız bulunmuyor." desc="Eğitimlerinize sınav eklendiğinde burada görüntülenecektir." testid="exams-empty" />
      ) : (
        <Stagger className="grid gap-5 md:grid-cols-2" gap={0.08}>
          {data.map((e) => (
            <AnimatedCard key={e.id} className="group flex flex-col p-6" data-testid={`exam-card-${e.id}`}>
              <div className="flex items-start justify-between gap-3">
                <div className="grid h-11 w-11 place-items-center rounded-xl bg-amber-50 text-amber-600 transition-transform duration-300 group-hover:-rotate-6">
                  {e.passed ? <Trophy className="h-5 w-5" /> : <ClipboardList className="h-5 w-5" />}
                </div>
                <Badge status={e.passed ? "passed" : e.attempts_used > 0 && !e.can_attempt ? "failed" : "pending"} testid="exam-status-badge" />
              </div>
              <h3 className="mt-4 text-lg font-bold text-[var(--ink)]">{e.title}</h3>
              <p className="text-sm text-slate-500">{e.course_title}</p>
              <dl className="mt-5 grid grid-cols-3 gap-3 rounded-xl bg-slate-50 p-3 text-center">
                <div><dt className="text-[11px] text-slate-400">Soru</dt><dd className="font-bold">{e.question_count}</dd></div>
                <div><dt className="text-[11px] text-slate-400">Geçme</dt><dd className="font-bold">{e.pass_score}</dd></div>
                <div><dt className="text-[11px] text-slate-400">Deneme</dt><dd className="font-bold" data-testid="exam-attempts">{e.attempts_used}/{e.max_attempts}</dd></div>
              </dl>
              {e.best_score !== null && <p className="mt-3 text-sm text-slate-500">En iyi puanınız: <span className="font-bold text-[var(--ink)]" data-testid="exam-best-score">{e.best_score}</span></p>}
              <div className="mt-auto pt-5">
                {e.can_attempt ? (
                  <Link to={`/panel/sinavlarim/${e.id}`} className="btn-primary group/cta inline-flex h-11 w-full items-center justify-center gap-2 rounded-xl text-sm font-semibold" data-testid={`exam-start-btn-${e.id}`}>
                    {e.attempts_used ? "Tekrar Dene" : "Sınava Başla"} <ArrowRight className="h-4 w-4 transition-transform group-hover/cta:translate-x-1" />
                  </Link>
                ) : (
                  <p className="text-center text-sm font-medium text-slate-400">{e.passed ? "Bu sınavı başarıyla tamamladınız." : "Deneme hakkınız kalmadı."}</p>
                )}
              </div>
            </AnimatedCard>
          ))}
        </Stagger>
      )}
    </div>
  );
}
